/**
 * Custom hook for HTML5 drag-and-drop
 * Copied from PlaceLearnToRankPage pattern
 */

import type React from 'react'

interface DragApi {
  onDragStart: (draggedIndex: string) => void
  onDragEnter: (dropIndex: string) => void
  onDrop: () => void
}

interface NativeDragApi {
  onDragStart: (e: React.DragEvent<HTMLElement>) => void
  onDragOver: (e: React.DragEvent<HTMLElement>) => void
  onDragEnter: (e: React.DragEvent<HTMLElement>) => void
  onDrop: (e: React.DragEvent<HTMLElement>) => void
}

export const useDragAndDrop = (dragApi: DragApi): NativeDragApi => {
  return {
    onDragStart: (e: React.DragEvent<HTMLElement>) => {
      e.currentTarget.blur()
      const draggedIndex = e.currentTarget.dataset.dragIndex
      if (draggedIndex) {
        dragApi.onDragStart(draggedIndex)
      }
    },
    onDragOver: (e: React.DragEvent<HTMLElement>) => {
      e.preventDefault()
    },
    onDragEnter: (e: React.DragEvent<HTMLElement>) => {
      e.currentTarget.focus()
      const dropIndex = e.currentTarget.dataset.dragIndex
      if (dropIndex) {
        dragApi.onDragEnter(dropIndex)
      }
    },
    onDrop: (e: React.DragEvent<HTMLElement>) => {
      e.preventDefault()
      dragApi.onDrop()
    },
  }
}
